import React, { useState } from "react";
// import styles from './password-reset.module.scss';
import styles from "../../widgets/password-reset/password-reset.module.scss";
import Link from "next/link";

// import Button from '../../elements/button';
import Button from "./Button";
import Card from "../../elements/card";
import Heading, { SmallText, Subheading } from "../../elements/text";
import Input from "./Input";
import Image from "next/image";
import { leftArrow } from "../../../assets/icons";
import { passwordResetValidationSchema } from "../../../utils";

import { Formik, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { resetPassword } from "../../../api-client/reset-password";

const Security = () => {
  const [loading, setLoading] = useState(false);
  return (
    <>
      <section className="flex lg:justify-center border-[1px] border-[#B3BAC5] items-center lg:py-16 py-10 rounded-[20px]">
        <div className="  w-full     px-5  flex items-ceter  flex-col ">
          {/* <p className="text-[#061938] leading-[20px] lg:text-[18px] text-[14px]  font-[600] pl-5 ">
            Change Password
          </p> */}

          <Formik
            // Initialise Initial Form Values
            initialValues={{ email: "" }}
            // Function for Error message Display
            validationSchema={passwordResetValidationSchema}
            // Submit Function
            onSubmit={async (data) => {
              setLoading(true);
              try {
                const res = await resetPassword(data);

                toast.success(res.data.message);
                setLoading(false);
              } catch (error) {
                toast.error(error.response.data.message);
                setLoading(false);
              }
            }}
          >
            {({ values, handleChange, handleSubmit, errors, touched }) => (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="flex lg:flex-row flex-col lg:items-center justify-between "
              >
                <div>
                  <p className="text-[#061938] leading-[2px] lg:text-[18px] text-[14px]   font-[600] pl-5">
                    Change Password
                  </p>
                  <Input
                    type="email"
                    placeholder="Manage and Update your Password"
                    className={[styles.input, "w-full -py-4 -mt-3 "].join(" ")}
                    onChange={handleChange}
                    error={errors.email && touched.email}
                    value={values.email}
                    name="email"
                  />
                </div>
                <ErrorMessage name="email">
                  {(msg) => (
                    <SmallText>
                      <p className="error-text mb-4">{msg}</p>
                    </SmallText>
                  )}
                </ErrorMessage>
                <Button
                  className="border-[#205363] border-[1px] py-4 text-[12px] mb-5 font-bold text-[#205363]  px-4 w-[240px] "
                  label="Reset Password"
                  type="submit"
                  loading={loading}
                />
              </form>
            )}
          </Formik>
        </div>
      </section>
    </>
  );
};
export default Security;
